import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { ViewHeader2Page } from "./../view-header2/view-header2";
import { ServiceProvider } from "./../../providers/service/service";
import { RequestOptions, Headers, Http } from "@angular/http";
import { QuizPage } from "./../quiz/quiz";
import { WaitStep3Page } from "./../wait-step3/wait-step3";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-quiz-result",
  templateUrl: "quiz-result.html",
})
export class QuizResultPage {
  quizTrue: any = "";
  quizTotal: any = "";
  round: any;
  theme = 1;

  constructor(
    private storage: Storage,
    public navCtrl: NavController,
    private http: Http,
    private services: ServiceProvider,
    private translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("quizResult").then((quizResult) => {
      if (quizResult.quiz_true > quizResult.quiz_total) {
        this.quizTrue = quizResult.quiz_total;
      } else {
        this.quizTrue = quizResult.quiz_true;
      }

      this.quizTotal = quizResult.quiz_total;
    });

    this.storage.get("quizRound").then((round) => {
      this.round = round;
    });
  }

  continue() {
    this.storage.get("quizRound").then((round) => {
      if (round == 2) {
        this.storage.remove("quizRound");
        this.storage.remove("quizResult");
        this.storage.remove("quiz");

        this.storage.get("token").then((token) => {
          var headers = new Headers();
          headers.append("Content-Type", "application/x-www-form-urlencoded");
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });
          var link = this.services.URLUserStatEnd;
          this.http
            .post(link, "", requestOptions)
            .map((res) => res.json())
            .subscribe((data2) => {
              this.storage.set("stepGame", "waitStep3");
              this.navCtrl.setRoot(WaitStep3Page);
            });
        });
      } else {
        this.storage.set("quizRound", "2");
        this.storage.remove("quizResult");
        this.storage.remove("quiz");
        this.navCtrl.setRoot(QuizPage);
      }
    });
  }

  doRefresh(refresher) {
    var link = this.services.URLCheckStep;

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              if (data.step >= 3) {
                this.storage.remove("quizRound");
                this.storage.remove("quizResult");
                this.storage.remove("quiz");
                this.storage.set("stepGame", "home");

                if (info.role == 1) {
                  this.navCtrl.setRoot(HomePage);
                } else if (info.role == 2) {
                  this.navCtrl.setRoot(MerchantHomePage);
                } else if (info.role == 3) {
                  this.navCtrl.setRoot(ShopperHomePage);
                }
              }
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });

    refresher.complete();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/quiz-result/quiz-result.ts